import {
  fetchTeamsByRoom,
  createTeam,
  updateTeam,
  deleteTeam,
  bulkAssignPlayersToTeams,
  BulkPlayerAssignment,
  bulkSetTeamCommunicators,
} from '@/api/team'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { BulkCommunicatorAssignment } from '@/redux/types/teamChat'

export const fetchTeamsByRoomId = createAsyncThunk(
  'team/fetchTeamsByRoom',
  async (roomId: string, thunkAPI) => {
    try {
      const response = await fetchTeamsByRoom(roomId)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const createNewTeam = createAsyncThunk(
  'team/createTeam',
  async (
    {
      roomId,
      teamData,
    }: { roomId: string; teamData: { name: string; description?: string } },
    thunkAPI
  ) => {
    try {
      const response = await createTeam(roomId, teamData)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const updateExistingTeam = createAsyncThunk(
  'team/updateTeam',
  async (
    {
      teamId,
      teamData,
    }: { teamId: number; teamData: { name: string; description?: string } },
    thunkAPI
  ) => {
    try {
      const response = await updateTeam(teamId, teamData)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const deleteExistingTeam = createAsyncThunk(
  'team/deleteTeam',
  async (teamId: number, thunkAPI) => {
    try {
      await deleteTeam(teamId)
      return teamId
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const bulkAssignPlayersToTeamsThunk = createAsyncThunk(
  'team/bulkAssignPlayersToTeams',
  async (
    {
      roomId,
      assignments,
    }: { roomId: string; assignments: BulkPlayerAssignment[] },
    thunkAPI
  ) => {
    try {
      const response = await bulkAssignPlayersToTeams(roomId, assignments)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)

export const bulkSetTeamCommunicatorsThunk = createAsyncThunk(
  'team/bulkSetTeamCommunicators',
  async (
    {
      roomId,
      assignments,
    }: { roomId: string; assignments: BulkCommunicatorAssignment[] },
    thunkAPI
  ) => {
    try {
      const response = await bulkSetTeamCommunicators(roomId, assignments)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue((error as Error).message)
    }
  }
)
